export enum FileSeparator {
    COMMA = 'COMMA',
    SEMICOLON = 'SEMICOLON',
    TAB = 'TAB',
    HIGHBAR = "HIGHBAR"
}